var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "add-to-cart-check" }, [
      _c("div", { staticClass: "add-to-cart-check__icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }